// import axios from 'axios'
import { post, put, get } from '@/api/api'

export const actions = {
  fetchProgrammes ({ commit}) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/programmes`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
  fetchProgrammesActualise ({ commit}) {///canal/programmes/actualise
    return get(`/canal/programmes/actualise`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
   fetchProgrammesLanding ({ commit,payload}) {///canal/programmes/landing/{id}
    return get(`/canal/programmes/landing/${payload.id}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
  fetchProgrammesSalle ({ commit,payload}) {//Liste des programmes vendable de la semaine en cours en fonction de la salle et du film
    return get(`/canal/programmes/sale/${payload.idSalle}/${payload.idFilm}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
  fetchProgrammesSalle ({ commit,payload}) { ///canal/programmes/salles/{idFilm}
    return get(`/canal/programmes/salle/${payload.idFilm}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
   fetchProgrammesSearchNom ({ commit,payload}) { ///canal/programmes/search/{nom}
    return get(`/canal/programmes/search/${payload.nom}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
  fetchProgrammesSearchNomCategeorie ({ commit,payload}) { ///canal/programmes/search/{nom}/{categorie}
    return get(`/canal/programmes/search/${payload.nom}/${payload.categorie}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },
   /* fetchProgrammesSepecific ({ commit,payload}) { ///canal/programmes/specific/{idFilm}
    return get(`/canal/programmes/search/${payload.idFilm}`)
      .then(({ data }) => {
        commit('addProgrammes', data)
      })
  },  */
  fetchProgrammesSepecific ({commit}, idSalle) { 
    let data = get(`/canal/programmes/specific/salle/${idSalle}`)
    return data
  },
  createProgramme ({ commit }, programme) {
    return post('/canal/programmes', programme)
      .then(({ data }) => {
        commit('addProgramme', data)
      })
  },
  updateProgramme ({ commit }, programme) {
    return put(`/canal/programmes/${programme.id}`, programme)
      .then(({ data }) => {
        commit('replaceProgramme', data)
      })
  },
  createOrUpdateProgramme ({ dispatch }, programme) {
    if (programme.id !== undefined) {
      return dispatch('updateProgramme', programme)
    } else {
      return dispatch('createProgramme', programme)
    }
  },
  selectProgramme ({ commit }, programme) {
    commit('setProgramme', programme)
  }
}
